import React, { Component } from "react";
import "./css/ImageText.css";

export default class ImageText extends Component {
  render() {
    const image = (
      <img className="imageText-image" src={this.props.image} alt="" />
    );
    const text = (
      <div className="imageText-text">
        <h4>{this.props.title.toUpperCase()}</h4>
        <p>{this.props.description}</p>
      </div>
    );

    if (this.props.orientation === "leftright") {
      return (
        <div className="imageText" style={this.props.style}>
          {image}
          {text}
        </div>
      );
    } else {
      return (
        <div className="imageText" style={this.props.style}>
          {text}
          {image}
        </div>
      );
    }
  }
}
